
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Interactive"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerInteractive"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"walkableProps"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"attempt"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"components"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"progressWithScore"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"scope"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"asset"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"walkablePlugin"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"metadataFields"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"config"},"arguments":[],"directives":[]}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"interactiveById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cohortId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deploymentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interactiveId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learn"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cohort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cohortId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cohortId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deployment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deploymentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deploymentId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interactive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"interactiveId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interactiveId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Interactive"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ancestry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cohortId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cohortId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"elementId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"elementType"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":876}};
    doc.loc.source = {"body":"#import \"./fragment/walkablePlugin.gql\"\n#import \"./fragment/attempt.gql\"\n#import \"./fragment/components.gql\"\n#import \"./fragment/walkableProps.gql\"\n#import \"./fragment/progressWithScore.gql\"\n#import \"./fragment/scope.gql\"\n#import \"./fragment/asset.gql\"\n#import \"./fragment/metadataFields.gql\"\n\nfragment Interactive on LearnerInteractive {\n  ...walkableProps\n  ...attempt\n  ...components\n  ...progressWithScore\n  ...scope\n  ...asset\n  ...walkablePlugin\n  ...metadataFields\n  config\n}\n\nquery interactiveById ($cohortId: UUID!, $deploymentId: UUID!, $interactiveId: UUID!) {\n  learn {\n    cohort (cohortId: $cohortId) {\n      deployment (deploymentId: $deploymentId) {\n        interactive (interactiveId: $interactiveId) {\n          ...Interactive\n          ancestry(cohortId: $cohortId) {\n            elementId\n            elementType\n          }\n        }\n      }\n    }\n  }\n}\n\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./fragment/walkablePlugin.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./fragment/attempt.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./fragment/components.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./fragment/walkableProps.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./fragment/progressWithScore.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./fragment/scope.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./fragment/asset.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./fragment/metadataFields.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["interactiveById"] = oneQuery(doc, "interactiveById");
        
